import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import { createAuthBackend } from "hooks/useAuthentication";
export default (payload, formValues, serviceType, shouldUpdateGroupSync = true) => {
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const notifyOnSuccess = () => UserNotification.success(
    i18n.t("notifications.create_success", { ns: "authentication" }),
    i18n.t("notifications.success_title", { ns: "authentication" })
  );
  const notifyOnError = (error) => UserNotification.error(
    i18n.t("notifications.create_failed", { ns: "authentication", error }),
    i18n.t("notifications.error_title", { ns: "authentication" })
  );
  return createAuthBackend(payload).then((result) => {
    if (result.backend && formValues.synchronizeGroups && enterpriseGroupSyncPlugin && shouldUpdateGroupSync) {
      return enterpriseGroupSyncPlugin.actions.onDirectoryServiceBackendUpdate(false, formValues, result.backend.id, serviceType).then(notifyOnSuccess).then(() => result);
    }
    notifyOnSuccess();
    return result;
  }).catch((error) => {
    notifyOnError(error);
    throw error;
  });
};
